/**
 * dashboardApi — the per-external-service controller (API service boundary
 * rule). Stores call THIS, never the transport. Signatures take typed domain
 * inputs; the transport and route strings stay private to the api layer.
 */

import { getDeployments, getInvoices, getSummary } from './apiClient'
import { mapDeployments, mapInvoicePage, mapSummary } from './mappers'
import type { Deployment, DeploymentSummary, InvoicePage, SyncStatus } from '@domain/types'

/** Fleet enumeration — slice 1 expects exactly the Mount Meru deployment. */
export async function fetchDeployments(signal?: AbortSignal): Promise<readonly Deployment[]> {
  return mapDeployments(await getDeployments(signal))
}

/**
 * FR-1 summary counts for one deployment and inclusive period
 * (yyyy-MM-dd strings; boundary-inclusive per FR-5).
 */
export async function fetchSummary(
  tinBranch: string,
  period: { from: string; to: string },
  signal?: AbortSignal,
): Promise<DeploymentSummary> {
  return mapSummary(await getSummary(tinBranch, period.from, period.to, signal))
}

/**
 * FR-3 invoice rows for one deployment, status-filtered, cursor-paginated.
 */
export async function fetchInvoices(
  tinBranch: string,
  query: { status?: SyncStatus; from: string; to: string; cursor?: string; limit?: number },
  signal?: AbortSignal,
): Promise<InvoicePage> {
  return mapInvoicePage(await getInvoices(tinBranch, query, signal))
}
